export class ApprovePaymentDto {
  ValueApprovedPayment?: number;
}
